<template>
  <a-modal
    title="Form Changes"
    :visible="modalEdit"
    @ok="handleModalEditOk"
    @cancel="handleCancel"
    :maskClosable="false"
  >
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        Cancel
      </a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleModalEditOk">
        OK
      </a-button>
    </template>
    <a-form :form="formEdit">
      <a-form-item label="SPPD Detail">
        <a-select
          showSearch
          class="m-width-full"
          placeholder="Select sppd"
          @change="handleSppd"
          v-decorator="[
            'id_sppd_dtl',
            {
              rules: [{ required: true }],
              initialValue: dataParent.id_sppd_dtl,
            },
          ]"
        >
          <a-select-option v-for="item in sppdList" :key="item.id_sppd_dtl">
            <!-- <div class="select-option">
              <div v-if="!getScreen">
                <h4>{{ item.item_nm }}</h4>
                <small>|</small>
                <small>{{ item.kode_anggaran }}</small>
              </div>
              <h4 v-else>{{ item.item_nm }}</h4>
              <small>{{
                formatRupiah(item.saldo_anggaran)
                  .replace("Rp", "")
                  .replace(",00", "")
              }}</small>
            </div> -->

            <div class="elipsdiv">
                    <div class="elipsdiv-mouseover-label1" >
                      {{ item.item_nm }}
                      <small v-if="!getScreen"> | </small>
                      <small v-if="!getScreen">{{ item.kode_anggaran }}</small>
                    </div>
                    <div class="elipsdiv-mouseover-label2">
                        <b style="float: right">{{
                            formatCurrency("IDR",parseFloat(item.saldo_anggaran)).replace(",00", "")
                          }}
                        </b>
                    </div>
                  </div>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="Detail Name">
        <a-input
          v-decorator="[
            'detail_name',
            { rules: [{ required: true }], initialValue: dataParent.deskripsi },
          ]"
        ></a-input>
      </a-form-item>
      <a-form-item label="Date Usage">
        <a-date-picker
          placeholder="Select Date"
          :format="getDefaultDateFormat"
          v-decorator="[
            'tanggal_pemakaian',
            {
              rules: [{ required: true }],
              initialValue: moment(dataParent.tanggal_pemakaian),
            },
          ]"
        />
      </a-form-item>
      <a-form-item label="Credit">
        <a-input-number
          type="number"
          class="m-width-full m-text-align-right"
          :formatter="
            (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          "
          :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
          v-decorator="[
            'kredit',
            { rules: [{ required: true }], initialValue: dataParent.kredit },
          ]"
        />
      </a-form-item>
      <a-row :gutter="12">
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: dataParent.iscommision },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 12 }" :lg="{ span: 8 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: dataParent.without_note },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
        </a-row>
        <a-form-item label="Upload Transaction Document">
          <a-upload
            :showUploadList="true"
            :fileList="doctransfiles"
            :beforeUpload="beforedoctransUpload"
            :remove="handledoctransRemove"
            v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
          >
            <a-button>
              <a-icon type="upload" />&nbsp;Select File
            </a-button>
          </a-upload>
        </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  props: {
    modalEdit: Boolean,
    dataParent: {},
    sppdList: Array,
    reportingList: Array,
  },
  mixins: [CurrencyFormat],
  computed: {
    ...mapGetters(["getDefaultDateFormat", "getAuth", "getScreen"]),
  },
  data() {
    return {
      selectedSppd: [],
      sppd: [],
      confirmLoading: false,
      EnCommission: false,
      Viwithout_note: false,
      doctransfiles: [],
    };
  },
  beforeCreate() {
    this.formEdit = this.$form.createForm(this);
  },
  mounted(){
      this.EnCommission = this.dataParent.EnCommission;
    this.Viwithout_note = this.dataParent.Viwithout_note;
      this.doctransfiles = this.dataParent.doctransfiles;
  },
  methods: {
    moment,
    handleCancel(e) {
      Event.$emit("modalCancel", false);
      Event.$emit("fetchSppd", false);
      this.formEdit.resetFields();
    },
    submit(values) {
      let url =
        this.dataParent.type === "revised"
          ? "klaim_biaya_pd/revisi_detil_pemakaian_edit"
          : "klaim_biaya_pd/detil_pemakaian_edit";

      let addData = new FormData();
      addData.append("id", this.dataParent.id);
      addData.append("tanggal_pemakaian", values.tanggal_pemakaian.format("YYYY-MM-DD"));
      addData.append("sppd_dtl", values.id_sppd_dtl);
      addData.append("deskripsi", values.detail_name);
      addData.append("kredit", values.kredit);
      addData.append("iscommision", values.iscommision);
      // addData.append("without_note", values.without_note);
      addData.append("without_note", "1");
      if (this.doctransfiles && this.doctransfiles.length > 0) {
        this.doctransfiles.forEach((file) => {
          addData.append("file_upload", file);
        });
      }
      this.confirmLoading = true;
      axios({
        method: "post",
        url: this.$serviceUrl + url,
        processData: false,
        data: addData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          // "Content-Type": "application/json",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.formEdit.resetFields();
          Event.$emit("modalCancel", false);
          Event.$emit("fetchPemakaian", true);
          Event.$emit("fetchSppd", true);
        })
        .catch((err) => {
          console.log("error : " + err);
        });
        this.confirmLoading = true;
    },
    handleModalEditOk() {
      this.formEdit.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        } 

        if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
          this.displayMessageValue("error-other", "Usage date can't exceed today!");
          return;
        }

        //this.handleSppd(values.id_sppd_dtl);
        this.selectedSppd = this.sppdList.filter(
        (obj) => obj.id_sppd_dtl.toLowerCase().indexOf(values.id_sppd_dtl.toLowerCase()) >= 0
      );
        if (parseFloat(values.kredit) > parseFloat(this.selectedSppd[0].saldo_anggaran)) {
          this.displayMessage("over-kredit");
          return;
        }

        const selected = this.selectedSppd[0];
        const datalist = this.reportingList.filter(function(item) {
          if (
            item.deskripsi.toLowerCase() === values.detail_name.toLowerCase() &&
            item.item_nm === selected.item_nm
          ) {
            return item;
          }
        });

        if (datalist.length > 0) {
          let existLampName = null;
          if (this.doctransfiles && this.doctransfiles.length > 0)
            existLampName = this.doctransfiles[0].name
          if (
            moment(datalist[0].tgl_buat).format("DD-MM-YYYY") ==
              moment(values.tanggal_pemakaian).format("DD-MM-YYYY") &&
            datalist[0].kredit == values.kredit && datalist[0].iscommision == values.iscommision &&
            datalist[0].without_note == values.without_note &&
            datalist[0].lampiran == existLampName
          ) {
            this.displayMessage("form-duplicate");
            return;
          } else {
            this.submit(values);
          }
        } else {
          this.submit(values);
        }
      });
    },
    handleSppd(e) {
      this.selectedSppd = this.sppdList.filter(
        (obj) => obj.id_sppd_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      let selectedumDtl = _.filter(this.selectedSppd, { id_sppd_dtl: e });
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
        this.formEdit.setFieldsValue({
            without_note: "1",
        });
      });
    },
    handleChangeumDtl(val){
      let selectedumDtl = _.filter(this.dataParent.list_um, { id_um_dtl: val });
      //console.log(selectedumDtl,this.ppdetillist);
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.formEdit.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      gap: @padding / 2;
    }
  }
  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
      }
      &-selected-value {
        flex: 1;
        float:unset!important;
      }
    }
  }
}
.ant-select-selection-selected-value{
    width:100%!important;
  }
</style>
